import { useQuery } from "@tanstack/react-query";

import type { FreshnessMeta } from "@/lib/api";

import { getOverview, STALE_TIME } from "./api";
import { BoardTab } from "./BoardTab";
import { LeadsTab } from "./LeadsTab";
import { OpportunitiesTab } from "./OpportunitiesTab";
import { OverviewTab } from "./OverviewTab";
import { ReadoutsTab } from "./ReadoutsTab";

export function useDistributionMeta(enabled: boolean): FreshnessMeta | null | undefined {
  const head = useQuery({ queryKey: ["distribution", "overview"], queryFn: () => getOverview(), staleTime: STALE_TIME, enabled });
  return enabled ? head.data?.meta ?? null : undefined;
}

export function DistributionModule({ activeTabKey, areaName }: { decision: "edit" | "view" | "none"; activeTabKey: string | null; areaName: string; ownerName?: string | null }) {
  switch (activeTabKey) {
    case "opportunities": return <OpportunitiesTab areaName={areaName} />;
    case "board": return <BoardTab areaName={areaName} />;
    case "leads": return <LeadsTab areaName={areaName} />;
    case "readouts": return <ReadoutsTab areaName={areaName} />;
    default: return <OverviewTab areaName={areaName} />;
  }
}
